<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo"> 
      <i class="fas fa-warehouse icon"></i>
        Bodegas
      </div>
      
      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul> 
            <li>
              <router-link :to="{name:'administratorHome'}" >
                <span >
                  <i class="fas fa-home icon"></i>                  
                   inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{name: 'cellar'}">
                <span>
                 <i class="fas fa-warehouse icon"></i>
                    Bodegas
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div slot="contenido">
        <div class="box">

          <createCellars 
          v-if="isComponentModalActive"
          :isComponentModalActive="isComponentModalActive"
          :closeBasic="closeBasic"
          :chargeListCellars="chargeListCellars"
          :cellar_id="cellar_id">
          </createCellars>
          <b-button type="is-primary is-small" @click="openBasic()">Crear Bodega</b-button>

          <b-table type="is-primary"
            :data.sync="listCellars.data"
            :loading="loading"            
            :is-fullwidth="true"
            
         
            paginated
            backend-pagination
            :total="listCellars.total"
            :per-page="listCellars.per_page"
            @page-change="chargeListCellars"
          >
            <template slot-scope="props">
              <b-table-column field="id" label="ID" width="40" numeric>{{ props.row.id }}</b-table-column>

              <b-table-column searchable field="name" label="Nombre">{{ props.row.name }}</b-table-column>

              <b-table-column label="Action">
                        <b-button type="is-primary is-small" @click="editBasic(props.row.id)">Editar</b-button>

              </b-table-column>
            </template>
          </b-table>
          
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from '../../../../template/PlantillaContenido'
import createCellars from '../../../../components/manteiners/cellar/create';
import {CellarService} from "./../../../../services/models/cellar"

export default {
  components: {
    PlantillaContenido,
    createCellars
  },
  data() {
    return {
      cellar_id: null,
      listCellars: [],
      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      loading: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5
    };
  },
  mounted: function() {
    this.chargeListCellars();
  },
  methods: {
    openBasic() {
      this.isComponentModalActive = true;
    },
    closeBasic() {
      this.cellar_id = null;
      this.isComponentModalActive = false;
    },
    editBasic(id) {
      this.cellar_id = id;
      this.isComponentModalActive = true;
    },
    async chargeListCellars() {
      this.loading = true;
      this.listCellars = [];
      const {data} = await CellarService.getAll();
      this.listCellars = data;
      this.loading = false;
    }
  },
  
};
</script>

